import type {
  AuthenticatedSession,
  CreateJobInput,
  PublicJob,
  OpenAIVideoModel,
  StudioSettings,
} from "@farzin/contracts";

interface JobsResponse {
  readonly jobs: readonly PublicJob[];
}

interface JobResponse {
  readonly job: PublicJob;
}

interface ErrorResponse {
  readonly error?: string;
}

export class ApiClient {
  public constructor(private readonly initData: string) {}

  public async listJobs(): Promise<readonly PublicJob[]> {
    return (await this.request<JobsResponse>("/api/jobs")).jobs;
  }

  public async getSession(): Promise<AuthenticatedSession> {
    return this.request<AuthenticatedSession>("/api/session");
  }

  public async getSettings(): Promise<StudioSettings> {
    return this.request<StudioSettings>("/api/settings");
  }

  public async updateVideoModel(
    model: OpenAIVideoModel,
  ): Promise<StudioSettings> {
    return this.request<StudioSettings>("/api/owner/settings/video-model", {
      method: "PUT",
      body: JSON.stringify({ model }),
    });
  }

  public async createJob(input: CreateJobInput): Promise<PublicJob> {
    return (
      await this.request<JobResponse>("/api/jobs", {
        method: "POST",
        body: JSON.stringify(input),
      })
    ).job;
  }

  private async request<T>(path: string, init?: RequestInit): Promise<T> {
    const headers = new Headers(init?.headers);
    headers.set("content-type", "application/json");
    headers.set("x-telegram-init-data", this.initData);
    const response = await fetch(path, {
      ...init,
      headers,
    });
    if (!response.ok) {
      const payload = (await response
        .json()
        .catch(() => ({}))) as ErrorResponse;
      throw new Error(
        payload.error ?? `Request failed (${String(response.status)}).`,
      );
    }
    return (await response.json()) as T;
  }
}
